var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-area-input-modal',{ref:"input",attrs:{"title":_vm.title,"student":_vm.studentName,"byDefault":_vm.state,"edit":_vm.edit},on:{"selectedElement":_vm.propagateChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee0543a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryElements/MessageTextArea.vue
// module id = 254
// module chunks = 1